"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchUser = void 0;
var parseUser_1 = require("./parseUser");
var getOxygenId_1 = require("../common/getOxygenId");
var config_1 = require("../helpers/config");
var fetchWithTokenAndRegion_1 = require("../region/fetchWithTokenAndRegion");
var getCurrentToken_1 = require("../token/getCurrentToken");
var fetchUser = function () {
    return (0, getCurrentToken_1.getCurrentToken)().then(function (_a) {
        var accessToken = _a.accessToken;
        var oxygenId = (0, getOxygenId_1.getOxygenId)(accessToken);
        return (0, fetchWithTokenAndRegion_1.fetchWithTokenAndRegion)("".concat((0, config_1.getBim360AdminUrl)(), "/v1/users/").concat(oxygenId)).then(parseUser_1.parseUser);
    });
};
exports.fetchUser = fetchUser;
